import CheckMark from '@images/CheckMark.svg'
import { FC, HTMLProps } from 'react'
import { cn } from '@/lib/utils'

interface AdvantageItemProps extends HTMLProps<HTMLDivElement> {
	advantageText: string
}

export const AdvantageItem: FC<AdvantageItemProps> = ({ advantageText, ...rest }) => {
	return (
		<div {...rest} className={cn('flex gap-x-4 items-start', rest.className)}>
			<img src={CheckMark} alt='' className={'w-5 mt-[6px]'} />
			<p className={'text-wrap'}>{advantageText}</p>
		</div>
	)
}
